import { ArrowLeftOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'
import { withFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import * as Yup from 'yup'
import Button from '../../../Components/Button'
import Field from '../../../Components/Formik/Field'
import Form from '../../../Components/Formik/Form'
import apiClient from '../../../Util/apiClient'
import { convertSelectOptions } from '../../../Util/Util'

const BILLABLE_OPTIONS = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' }
]

const projectSchema = Yup.object().shape({
  name: Yup.string().required(),
  client: Yup.string().required(),
  billable: Yup.string().required()
})

function WarehouseForm({
  setValues,
  match: {
    params: { id }
  }
}) {
  const [clientOptions, setClientOptions] = useState([])

  const getData = () => {
    if (id) {
      apiClient.get(`projects/byId/${id}`).then(({ status, data }) => {
        if (status === 200 && data.result) {
          setValues(data.result)
        }
      })
    }

    apiClient.get('clients/getAllActive').then(({ status, data }) => {
      if (status === 200 && data.result) {
        setClientOptions(convertSelectOptions(data.result || [], 'name', 'id'))
      }
    })
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <Form>
      <Row justify="center" className="inner-contents">
        <Col xs={{ span: 22 }} sm={{ span: 22 }} md={{ span: 20 }} lg={{ span: 20 }}>
          <div className="panel-layout">
            <h2 className="panel-title">Project Definition</h2>

            <div className="panel-design">
              <div className="panel-header">
                <h3>Project</h3>
              </div>
              <div className="panel-body">
                <Row gutter={[20, 10]}>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
                    <div className="form-field">
                      <Field name="name" label="Name" />
                    </div>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
                    <div className="form-field">
                      <Field as="select" name="client" label="Client" options={clientOptions} />
                    </div>
                  </Col>
                  <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
                    <div className="form-field">
                      <Field as="select" name="billable" label="Billable" options={BILLABLE_OPTIONS} />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>

          {/* Product details ends */}

          <div className="save-changes">
            <Button type="submit" variant="primary">
              {id ? 'Update' : 'Save'}
            </Button>
            <span>or</span>
            <Link to="/app/projects">
              <Button>
                <ArrowLeftOutlined /> Back to project list
              </Button>
            </Link>
          </div>
          {/* Invoice Information ends */}
        </Col>
      </Row>
    </Form>
  )
}

export default withFormik({
  mapPropsToValues: () => ({
    name: '',
    client: '',
    billable: ''
  }),
  validationSchema: projectSchema,
  handleSubmit: (
    data,
    {
      props: {
        match: {
          params: { id }
        },
        history
      }
    }
  ) => {
    if (id) {
      apiClient.put(`projects/update/${id}`, { ...data }).then(({ data }) => {
        if (data && data.result) {
          history.push('/app/projects')
        }
      })
    } else {
      apiClient.post('projects/add', data).then(({ data }) => {
        if (data && data.result) {
          history.push('/app/projects')
        }
      })
    }
  }
})(WarehouseForm)
